import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose, withProps } from 'recompose';

import { selectCurrentAppointment } from '../../../redux/appointmnents/selectors';
import * as appointmentDetails from '../../../redux/appointmnents/appointment-details-req';
import * as confirmUrgentVisit from '../../../redux/appointmentForm/requests/confirm-visit-urgent-req';
import {
  selectUrgentVisitPayload,
  selectProgressIsUrgentVisitFlow,
  selectUrgentVisitConfirmPending,
  selectAdditionalInfoFormData,
} from '../../../redux/appointmentForm/selectors';

const mapStateToProps = state => ({
  appointment: selectCurrentAppointment(state),
  isUrgentVisit: selectProgressIsUrgentVisitFlow(state),
  urgentVisitPayload: selectUrgentVisitPayload(state),
  additionalInfoFormData: selectAdditionalInfoFormData(state),
  urgentVisitPending: selectUrgentVisitConfirmPending(state),
});

const mapDispatchToProps = {
  resetAppointment: appointmentDetails.actions.clear,
  urgentVisitRequest: confirmUrgentVisit.actions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({
      resetAppointment,
      urgentVisitPayload,
      additionalInfoFormData = {},
      urgentVisitRequest,
    }) => ({
      confirmUrgentVisit: () => {
        resetAppointment();
        urgentVisitRequest({
          ...urgentVisitPayload,
          ...additionalInfoFormData,
        });
      },
    }),
  ),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentPayment/enhance.js